<topo-modal
  (close)="close()"
  [width]="width"
  [isActive]="isActive"
  [isCard]="true">
  <div class="modal-header">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <h5 class="mx-4 my-4">
        {{ isNew ? ('MANAGEMENT.WORKFLOW.NEW-RULE' | translate) : ('MANAGEMENT.WORKFLOW.EDIT-RULE' | translate) }}
      </h5>
      <div
        class="dialog-close close"
        (click)="close()">
        <i class="icon icon-close-X"></i>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="rule-section">
      <div
        fxLayout="row"
        fxLayoutAlign="left top">
        <div class="order-bullet">1</div>
        <div>
          <label>{{ 'MANAGEMENT.WORKFLOW.WHEN-THIS-HAPPENS' | translate }}</label>
          <div>
            <div class="select is-secondary is-medium">
              <select
                [(ngModel)]="selectedRuleEvent"
                (change)="ruleEventChanged($event)">
                @for (event of ruleEvents; track event.id) {
                  <option
                    [ngValue]="event.id">
                    {{ event.name }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      @if (isDateCriteria) {
        <div
          class="date-criteria">
          <label>{{ dateCriteriaLabel }}</label>
          <div
            fxLayout="row"
            fxLayoutAlign="left center">
            <div>
              @if (isAfterTime || isSchedules) {
                <input
                  class="input is-small value-input"
                  type="text"
                  [(ngModel)]="selectedOffsetValue" />
              }
            </div>
            @if (isAfterTime || isSchedules) {
              <div
                class="select is-secondary is-medium offest-select"
                >
                <select [(ngModel)]="selectedOffsetType">
                  @for (offsetType of offsetTypes; track offsetType.id) {
                    <option
                      [ngValue]="offsetType.id">
                      {{ offsetType.name }}
                    </option>
                  }
                </select>
              </div>
            }
            @if (isAfterTime) {
              <div
                class="select is-secondary is-medium dir-select"
                >
                <select [(ngModel)]="selectedOffsetDir">
                  @for (offsetDir of offsetDirs; track offsetDir.id) {
                    <option
                      [ngValue]="offsetDir.id">
                      {{ offsetDir.name }}
                    </option>
                  }
                </select>
              </div>
            }
            @if (isAfterTime) {
              <div
                class="select is-secondary is-medium source-select"
                >
                <select [(ngModel)]="selectedOffsetSource">
                  @for (offsetSource of offsetSources; track offsetSource.id) {
                    <option
                      [ngValue]="offsetSource.id">
                      {{ offsetSource.name }}
                    </option>
                  }
                </select>
              </div>
            }
            @if (isSpecificTime) {
              <div
                fxLayout="row"
                fxLayoutAlign="left center"
                class="date-select"
                >
                <div>
                  <input
                    [(ngModel)]="selectedOffsetDate"
                    class="input is-small"
                    type="datetime"
                    [matDatepicker]="picker" />
                  <mat-datepicker #picker></mat-datepicker>
                </div>
                <div>
                  <button
                    class="button is-ghost is-small"
                    (click)="picker.open()">
                    <i class="icon icon-calendar"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }
      <div class="rule-next"></div>
    </div>
    <div
      cdkDropList
      cdkDropListOrientation="vertical"
      (cdkDropListDropped)="actionDrop($event)">
      @for (action of rule?.actions; track action.uId; let i = $index) {
        <div>
          @if (editActionUId !== action.uId) {
            <div
              style="position: relative">
              <div
                fxLayout="row"
                fxLayoutAlign="start top"
                (mouseenter)="showActionsUId = editActionUId === null ? action.uId : null"
                (mouseleave)="showActionsUId = null"
                style="width: 100%">
                <div
                  cdkDrag
                  class="rule-section"
                  style="width: 100%; padding-bottom: 16px"
                  [ngClass]="{ 'section-disabled': editActionUId !== null && editActionUId !== action.uId }">
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start top">
                    @if (showActionsUId === action.uId && editActionUId === null && (rule?.actions.length > 1 || i > 0)) {
                      <div
                        cdkDragHandle
                        title="{{ 'MANAGEMENT.WORKFLOW.CHANGE-ORDER' | translate }}"
                        style="position: absolute; left: -4px; top: 28px; cursor: pointer">
                        <i class="icon icon-drag_handle drag-handle"></i>
                      </div>
                    }
                    <div
                      cdkDragHandle
                      class="order-bullet">
                      {{ i + 2 }}
                    </div>
                    <div cdkDragHandle>
                      <label>
                        {{ (i == 0 ? 'MANAGEMENT.WORKFLOW.PERFORM-THIS-ACTION' : 'MANAGEMENT.WORKFLOW.THAN-PERFORM-THIS-ACTION') | translate }}
                      </label>
                      <div
                        fxLayout="row"
                        fxLayoutAlign="left center">
                        <div
                          class="action-display"
                          (click)="editActionClick(action)"
                          [ngStyle]="{ width: rule?.actions.length > 1 || i > 0 ? '500px' : '545px' }">
                          <div
                            workflow-rule-action-edit
                            [readOnly]="true"
                            [schema]="schema"
                            [workflow]="workflow"
                            [step]="step"
                            [rule]="rule"
                            [action]="action"
                          [implementationUId]="action.implementationUId"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rule-next-action"></div>
                @if (editActionUId === null && (rule?.actions.length > 1 || i > 0)) {
                  <div
                    fxLayout="row"
                    fxLayoutAlign="end center">
                    <div
                      class="rule-delete"
                      title="{{ 'MANAGEMENT.WORKFLOW.DELETE-RULE' | translate }}"
                      (click)="deleteActionClick(action)"
                      style="padding: 0px; margin-left: 8px">
                      <i class="icon icon-remove_outline"></i>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (editActionUId === action.uId) {
            <div
              style="position: relative">
              <div
                fxLayout="row"
                fxLayoutAlign="start top"
                style="width: 100%">
                <div
                  class="rule-section"
                  style="width: 100%; padding-bottom: 16px">
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start top">
                    <div class="order-bullet">{{ i + 2 }}</div>
                    <div>
                      <label>
                        {{ (i == 0 ? 'MANAGEMENT.WORKFLOW.PERFORM-THIS-ACTION' : 'MANAGEMENT.WORKFLOW.THAN-PERFORM-THIS-ACTION') | translate }}
                      </label>
                      <div style="width: 100%">
                        <div>
                          <div
                            class="select is-secondary is-medium"
                            style="width: 300px">
                            <select [(ngModel)]="action.implementationUId">
                              @for (actionOption of ruleImplementations; track actionOption.uId) {
                                <option
                                  [ngValue]="actionOption.uId">
                                  {{ actionOption.name }}
                                </option>
                              }
                            </select>
                          </div>
                          <div
                            style="width: 100%"
                            workflow-rule-action-edit
                            [readOnly]="false"
                            [schema]="schema"
                            [workflow]="workflow"
                            [step]="step"
                            [rule]="rule"
                            [action]="action"
                          [implementationUId]="action.implementationUId"></div>
                        </div>
                        @if (action?.implementationUId !== null) {
                          <div
                            fxLayoutAlign="end top"
                            class="edit-icons"
                            >
                            <div>
                              <button
                                class="button is-secondary"
                                [disabled]="!canActionCancel"
                                (click)="cancelActionClick(action)">
                                {{ 'MANAGEMENT.WORKFLOW.CANCEL' | translate }}
                              </button>
                            </div>
                            <div class="ml-2 mr-2">
                              <button
                                class="button is-primary"
                                (click)="saveActionClick(action)">
                                {{ 'MANAGEMENT.WORKFLOW.APPLY' | translate }}
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rule-next-action"></div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div>
      <button
        class="button is-secondary is-small add-button"
        [ngClass]="{ disabled: editActionUId !== null }"
        title="{{ 'MANAGEMENT.WORKFLOW.ADD-ACTION' | translate }}"
        (click)="addActionClick()"
        style="border-radius: 6px">
        <i class="icon icon-add_plus_zoom-in"></i>
      </button>
    </div>
  </div>
  <div class="modal-footer">
    <div
      fxLayout="row"
      fxLayoutAlign="end"
      class="mt-4 mb-4">
      <div style="margin-right: 5px">
        <button
          class="button is-secondary"
          (click)="cancelClick()">
          {{ 'MANAGEMENT.WORKFLOW.CANCEL' | translate }}
        </button>
      </div>
      <div class="ml-1">
        <button
          class="button is-primary"
          [disabled]="!canSave"
          (click)="saveClick()">
          {{ 'MANAGEMENT.WORKFLOW.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</topo-modal>

<topo-confirm-delete
  [isActive]="showDeleteConfirmation"
(confirmResponse)="onConfirmDeleteAction($event)"></topo-confirm-delete>
